<template>
  <v-progress-circular
    :rotate="config.rotate"
    :size="config.size"
    :width="config.width"
    :value="onboardingProgress"
    :color="color"
    class="d-flex d-lg-none font800 font10"
  >
    {{ onboardingProgress }}%
  </v-progress-circular>
</template>
<script>
export default {
  name: 'CircularProgressBar',
  data() {
    return {
      // config of circular progress bar
      config : {
        rotate: -90,
        size: 40,
        width: 5,
      },
    };
  },
  props: ['onboardingProgress', 'color'],
  computed: {
    primaryShade1() {
      return this.$vuetify?.theme?.themes?.light?.primaryShade1;
    },
  },
  mounted() {
    this.changeProgressBarStyle();
  },
  methods: {
    // To init styles
    changeProgressBarStyle() {
      this.changeProgressBarColor('.v-progress-circular__overlay',this.color);
      this.changeProgressBarColor('.v-progress-circular__underlay',this.primaryShade1);
    },
    // To change color of the stroke of circular progress bar
    changeProgressBarColor(className,color) {
      const progressBar = document.querySelector(className);
      if (progressBar) {
        // changing css property 
        progressBar.style.stroke = color;
      }
    }
  }
};
</script>
